export default "__VITE_ASSET__dlxjmFv3__"